import { Component, OnInit } from '@angular/core';
import {  Params } from '@angular/router';
import { CotizacionesService } from './../../services/cotizaciones.service';
import {  UsuariosPersonalService} from './../../services/usuarios-personal.service';
import { ClientesService} from './../../services/clientes.service';
import { Observable } from 'rxjs/Observable';
// Angular Fire
@Component({
    templateUrl: './info-ventas-diarias.component.html',
    styleUrls: ['../cotizacion/cotizacion.css']
})

export class InfoVentasDiariasComponent implements OnInit {

	constructor(
        private personalService:UsuariosPersonalService,
        private cotizacionesService: CotizacionesService,
    ){}
    listaCotizaciones:Array<any>=[];
    cotizacionesConfirmadas:number=0;
    cotizacionesEnvidas:number=0;
    cotizacionesVistas:number=0;
    listaClientes=[];
    listaNumeroDeCotizaciones=[];
    fechaSeleccionada:any;
    listaEnvidas={};
    ngOnInit(){
        let hoy = new Date(Date.now()); // momento ahora
        let hoyInicio = hoy.setHours(0,0,0); // Obtiene la hora minima del día
        let hoyFin = hoy.setHours(23,59,59,999);

        let mesActual:any= (hoy.getMonth()+1)
        if(mesActual <10) //Si el mes es menor a 10 agrega un 0
            mesActual= '0'+mesActual
        let diaActual:any= hoy.getUTCDate()-1
        if(diaActual <10) //Si el dia es menor a 10 agrega un 0
            diaActual= '0'+diaActual
        this.fechaSeleccionada= hoy.getFullYear()+'-'+ mesActual+'-'+diaActual;

       this.datosPorFecha(this.fechaSeleccionada)
    }
    datosPorFecha(fecha){
        //Se limpian las varables usadas para las estadisicas
        this.cotizacionesConfirmadas=0;
        this.cotizacionesEnvidas=0;
        this.cotizacionesVistas=0
        this.listaCotizaciones=[];

        //Se convierte el parametro de fecha en un arreglo
        let fechaArreglo=fecha.split('-');
        //Se convierte em un timestamp la fecha
        let fechaTime= new Date(Number(fechaArreglo[0]),Number(fechaArreglo[1]-1),Number(fechaArreglo[2])).getTime();
        //Se configura que este inicializada a las 0 horas
        let inicioFcha = new Date(new Date(fechaTime).setHours(0,0,0)).getTime()
        //Se configura la fecha din inicialiada en el ultimo  segundo del dia
        let finFcha = new Date(new Date(fechaTime).setHours(23,59,59,999)).getTime()+10000
        //Se solicita un servicio que obtiene las cotizaciones entre 2 fechas
        this.cotizacionesService.obtenerCotizacionesPorFecha(inicioFcha,finFcha).snapshotChanges().take(1).subscribe(lista=>{
            //Se limpian los arreglos de los diferetes datos que se muestran en pantalla
            let arreglo=[];
            let arregloClientes={};
            this.listaClientes=[];
            this.listaEnvidas={};
            this.cotizacionesConfirmadas=0;
            this.cotizacionesEnvidas=0;
            this.cotizacionesVistas=0;
            //Se empieza a recorrer el arreglo y a llenar los demas arreglos con los datos de la cotizaciones diarias
            lista.forEach(cotizacion=>{
                let $key = cotizacion.key
                let data = cotizacion.payload.val();
                //Se omiten las cotizaciones del ususario SAM BIGOTES JUNIOR
                if(data.estatus =='Confirmada' && data.usuarioQueCotizo != 'mL64yuZTxEUNtqMaSomH46LO0fq2')
                    this.cotizacionesConfirmadas ++;
                if(data.fueEnviada == true && data.usuarioQueCotizo != 'mL64yuZTxEUNtqMaSomH46LO0fq2')
                    this.cotizacionesEnvidas++;
                if(data.fueLeida == true && data.usuarioQueCotizo != 'mL64yuZTxEUNtqMaSomH46LO0fq2')
                    this.cotizacionesVistas++;
                   if(data.usuarioQueCotizo != 'mL64yuZTxEUNtqMaSomH46LO0fq2'){
                        arreglo.push({'nombre':data.usuarioQueCotizo,...data})

                    if(!arregloClientes[data.usuarioQueCotizo.toString()])
                    arregloClientes[data.usuarioQueCotizo.toString()] ={
                        leidas:0,
                        enviadas:0,
                        cotizaciones:0,
                        confirmadas:0
                    };
                    if(data.estatus == 'Confirmada'){
                        arregloClientes[data.usuarioQueCotizo.toString()].confirmadas = data.estatus ? arregloClientes[data.usuarioQueCotizo.toString()].confirmadas+1 : arregloClientes[data.usuarioQueCotizo.toString()].confirmadas;
                    }
                    arregloClientes[data.usuarioQueCotizo.toString()].leidas = data.fueLeida ? arregloClientes[data.usuarioQueCotizo.toString()].leidas+1 : arregloClientes[data.usuarioQueCotizo.toString()].leidas;
                    arregloClientes[data.usuarioQueCotizo.toString()].cotizaciones = data.usuarioQueCotizo ? arregloClientes[data.usuarioQueCotizo.toString()].cotizaciones+1 : arregloClientes[data.usuarioQueCotizo.toString()].cotizaciones;
                    arregloClientes[data.usuarioQueCotizo.toString()].enviadas = data.fueEnviada ? arregloClientes[data.usuarioQueCotizo.toString()].enviadas+1 : arregloClientes[data.usuarioQueCotizo.toString()].enviadas;
                   }
                   //
            })
            this.listaEnvidas =arregloClientes;
            this.listaCotizaciones = arreglo;
        })
    }
    verificarClientesRepetidos(){
        this.listaClientes=[];
        for (const key in this.listaEnvidas) {
            if (this.listaEnvidas.hasOwnProperty(key)) {
                const element = this.listaEnvidas[key];
                this.listaClientes.push({key,...element})
            }
        }
    }
}




// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/components/info-ventas-diarias/info-ventas-diarias.component.ts